import { gql } from '@apollo/client';

export const PromotionalCardsRepeaterQuery = gql`
    query PromotionalCardsRepeater($locale: Locale) {
        promotionalCardsRepeater(locale: $locale) {
            id
            title
            description
            ctaText
            ctaUrl
            backgroundColor
            imageUrl
            imageHoverUrl
            isPrioritized
            type
        }
    }
`;
